import { Upsell } from "@dreamhub/designsystem/icons";
import EmptyPage from "@/components/layouts/EmptyPage";

const Upsells = () => (
  <div data-test="upsells-page">
    <EmptyPage pageName="upsells" mainIcon={<Upsell />} />
  </div>
);

export default Upsells;
